export default {
  computed: {
    dispatchRequestId() {
      return this.$route.params.dispatchRequestId;
    },
    loadGroupId() {
      return this.$route.params.loadGroupId;
    },
    bookedLoadId() {
      return this.$route.params.bookedLoadId;
    },
    repeatLoadId() {
      return this.$route.params.repeatLoadId;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/loadsRoutingMixin.js